import { useState } from 'react'
import { TextField, Grid, Button, Avatar, AvatarGroup } from '@mui/material';

import commenticon from './../../../assets/home/newsfeed/commenticon.png'
import likeicon from './../../../assets/home/newsfeed/likeicon.png'
import likereaction from './../../../assets/home/newsfeed/likereaction.png'
import lovereaction from './../../../assets/home/newsfeed/lovereaction.png'
import hahareaction from './../../../assets/home/newsfeed/hahareaction.png'
import wowreaction from './../../../assets/home/newsfeed/wowreaction.png'
import sadreaction from './../../../assets/home/newsfeed/sadreaction.png'
import angryreaction from './../../../assets/home/newsfeed/angryreaction.png'

import '../../../scss/common.scss'
import EditPost from './edit-post';
import PostReactionModel from './post-reaction-model';



const showPostData: any = [{
    id: 5,
    username: "Eva Smith",
    profileimage: require("./../../../assets/home/newsfeed/profile.png"),
    time: "19 Days. ",
    audience: "Comapnay",
    posttext: "Hello! We are pleased to announce the Employee of the Month (April 2022) After careful assessment of performance on the project and discipline, this employee stands out. Cheers @Adam John",
    postimage: require("./../../../assets/home/newsfeed/postimage.png")
},
{
    id: 6,
    username: "Eva Smith",
    profileimage: require("./../../../assets/home/newsfeed/profile.png"),
    time: "05 Days. ",
    audience: "Comapnay",
    posttext: "Hi All! Today we are all going for Dinner arranged by Management for all employees. Venue: Dino Valley Timings: 3pm to 10pm Shifts: All",
    postimage: ""
},
{
    id: 7,
    username: "Victoria Ferguson",
    profileimage: require("./../../../assets/home/newsfeed/profileimage2.png"),
    time: "19 Days. ",
    audience: "Comapnay",
    posttext: "Hello! We are pleased to announce the Employee of the Month (April 2022) After careful assessment of performance on the project and discipline, this employee stands out. Cheers @Adam John",
    postimage: require("./../../../assets/home/newsfeed/postimage2.png")
},
{
    id: 8,
    username: "Eva Smith",
    profileimage: require("./../../../assets/home/newsfeed/profile.png"),
    time: "19 Days. ",
    audience: "Comapnay",
    posttext: "Hello! We are pleased to announce the Employee of the Month (April 2022) After careful assessment of performance on the project and discipline, this employee stands out. Cheers @Adam John",
    postimage: require("./../../../assets/home/newsfeed/postimage.png")
}

]


const ShowPost = (props: any) => {
    const {convertedContent, addData } =props;
    const [showCommentBox, setShowCommentBox] = useState(false)
    const [countReactions, setCountReactions] = useState(0)
    const [idd, setId] = useState(0)
    const [postData, setPostData] = useState(showPostData)
console.log(idd)
    const [like, setLike] = useState(false)
    const [love, setLove] = useState(false)
    const [haha, setHaha] = useState(false)
    const [wow, setWow] = useState(false)
    const [sad, setSad] = useState(false)
    const [angry, setAngry] = useState(false)

    const showCommentBoxHandler = () => {
        setShowCommentBox(true)
    }
//  console.log("wow Reacted", wow)
if(postData.length>0){
    postData[idd]["reactioncount"] = countReactions;
}

    if (convertedContent && addData) {
        postData.unshift(
            {
                username: "Eva Smith",
                profileimage: require("./../../../assets/home/newsfeed/profile.png"),
                time: "19 Days. ",
                audience: "Comapnay",
                "posttext": props.convertedContent,
            }
        )
    }

let text:any = "Mr. @Blue has a blue house";
let position:any = text.split(" ");


// let positionend:any = text.indexOf("@")
// console.log(positionend)

// let text1 = "Hello world!";
// let result = text1.substr(1, 4);


// var str = "Hello! We are pleased to announce the Employee of the Month (April 2022) After careful assessment of performance on the project and discipline, this employee stands out. Cheers @Adam John";
// var regex =   "/([@])\w+/g"
// var matches = str.exec(regex);
// console.log(matches)

    return (
        <div>
            {postData.map((item: any, index: any) => {
                return (
                    <div key={index} className='br-16 post post1' style={{ marginBottom: "30px" }}>
                        <div className='d-flex'>
                            <img className='user-avatar' src={item.profileimage} alt="" style={{ paddingRight: "20px" }} />
                            <div style={{display: "flex", justifyContent: "space-between", width: "100%"}}>
                            <div>
                                <h4 className='usertitle-color fw-600'>{item.username}</h4>
                                <span className='font-size-12 fw-500'>{item.time}</span>
                                <span className='font-size-12 fw-500 '>{item.audience}</span>
                            </div>
                            <div>
                            <EditPost idd={item.id} postData={postData} setPostData={setPostData} />
                            </div>
                            </div>
                        </div>
                        <p style={{ margin: "20px 0px" }}>{item.posttext} </p>
                        <img src={item.postimage} className="post-image" alt="" />
                        {(item.index !== item.id) ? <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }} >
                            <AvatarGroup className='reaction-icons' max={2}>
                                {like ?
                                    <Avatar src={likereaction} alt="" />
                                    : null
                                }
                                {love ?
                                    <Avatar src={lovereaction} alt="" />
                                    : null
                                }
                                {haha ?
                                    <Avatar src={hahareaction} alt="" />
                                    : null
                                }
                                {wow ?
                                    <Avatar src={wowreaction} alt="" />
                                    : null
                                }
                                {sad ?
                                    <Avatar src={sadreaction} alt="" />
                                    : null
                                }
                                {angry ?
                                    <Avatar src={angryreaction} alt="" />
                                    : null
                                }
                            </AvatarGroup>
                            {countReactions == 1 ? <span>You reacted</span>
                                : countReactions > 1 ? <span>You and {countReactions - 1} other people reacted</span>
                                    : null}
                        </div> : null}
                        <Grid className='d-flex post-options responsive-comment-like ' style={{ justifyContent: "space-around", padding: "10px", marginTop: "20px", position: "relative" }} >
                            <Grid className='d-flex justify-center' xs={4}>
                                <img src={likeicon} alt="" />
                                {/* <Button onClick={() => { setId(index); setOpenModal(true); }} >React</Button> */}
                                <PostReactionModel  setAngry={setAngry} setSad={setSad} setWow={setWow} setHaha={setHaha} setLike={setLike} setLove={setLove}  setCountReactions={setCountReactions} countReactions={countReactions}/>
                                {/* {openModal && (idd == item.id) ? <PostReactionModel setAngry={setAngry} setSad={setSad} setWow={setWow} setHaha={setHaha} setLike={setLike} setLove={setLove} open={openModal} onClose={() => setOpenModal(false)} setCountReactions={setCountReactions} countReactions={countReactions} setOpenModal={setOpenModal} /> : null} */}

                            </Grid>
                            <Grid className='d-flex justify-center ' xs={4}>
                                <img src={commenticon} alt="" />
                                <Button onClick={showCommentBoxHandler}>Comment</Button>
                            </Grid>
                        </Grid>
                        {showCommentBox && (idd == item.id) ? <div style={{ marginTop: 15 }}>
                            <TextField
                                fullWidth
                                placeholder="Have something to say?"
                                id="outlined-multiline-static"
                                multiline
                                rows={4}
                            />
                            <div>
                                <span style={{ margin: 10 }}>A</span>
                                <span style={{ margin: 10 }}>Emoji</span>
                                <span style={{ margin: 10 }}>@</span>
                            </div>
                            <div className='d-flex justify-end' style={{ paddingTop: 50 }}>
                                <Button sx={{
                                    color: "#A9A9A9", background: "#F1EFF2", padding: "13px 35px", fontWeight: 600, fontSize: 16, '&:hover': {
                                        backgroundColor: '#F1EFF2',
                                    },
                                }} onClick={() => { setShowCommentBox(false) }} className=''>Cancel</Button>
                                <Button sx={{
                                    color: "#fff", padding: "13px 35px", fontWeight: 600, fontSize: 16, '&:hover': {
                                        backgroundColor: '#F78812',
                                    },
                                }} onClick={() => { setShowCommentBox(false); }} className='btn-secondary '>Post</Button>

                            </div>
                        </div> : null}
                    </div>
                )
            })}
        </div>
    )
}

export default ShowPost;